/* eslint-disable */
import React from 'react';

const FileApproverIcon = ({ size = 24, color = 'currentColor', className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke={color}
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 5.5A2.5 2.5 0 016.5 3H14l6 6v9.5A2.5 2.5 0 0117.5 21h-11A2.5 2.5 0 014 18.5v-13z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 13l1.5 1.5L15 10" />
  </svg>
);

export default FileApproverIcon;
